exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-container[data-v-0cdddedb] {\r\n  padding: 20px;\n}\r\n\r\n/* 搜索结果列表样式 */\n.search-results[data-v-0cdddedb] {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background: white;\r\n  border: 1px solid #dcdfe6;\r\n  border-radius: 4px;\r\n  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\r\n          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\r\n  max-height: 300px;\r\n  overflow-y: auto;\n}\n.search-result-item[data-v-0cdddedb] {\r\n  padding: 10px 15px;\r\n  cursor: pointer;\n}\n.search-result-item[data-v-0cdddedb]:hover {\r\n  background-color: #f5f7fa;\n}\r\n", ""]);

// exports
